import React from 'react';
import { Scale } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-400 py-16 border-t border-slate-800" data-id="element-148" data-mp="3gf94uw0pu68y">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-149" data-mp="3gh3qydnq44em">
        <div className="grid md:grid-cols-4 gap-8 mb-12" data-id="element-150" data-mp="32p5kybpb6omo">
          <div className="md:col-span-2" data-id="element-151" data-mp="36p6bgupomqa3">
            <div className="flex items-center gap-3 mb-4" data-id="element-152" data-mp="36pzb7bq84fiq">
              <div className="bg-slate-800 p-2 rounded-lg" data-id="element-153" data-mp="3ueiknul0eyce">
                <Scale className="w-5 h-5 text-brand-accent" data-id="element-154" data-mp="3ucxndx7b91au" />
              </div>
              <div className="flex flex-col" data-id="element-155" data-mp="387exl5219eq">
                <span className="font-serif font-bold text-lg leading-tight text-white" data-id="element-156" data-mp="3lelzw41qqjmm">
                  Pacific Coast
                </span>
                <span className="text-[10px] font-semibold tracking-widest text-slate-400 uppercase" data-id="element-157" data-mp="3qbvnde5kkl7t">
                  Mesothelioma Law Group
                </span>
              </div>
            </div>
            <p className="text-sm leading-relaxed max-w-md" data-id="element-158" data-mp="2ezuvhqdesgnu">
              Dedicated exclusively to representing California victims of
              asbestos exposure. We fight for the justice and compensation you
              deserve.
            </p>
          </div>

          <div data-id="element-159" data-mp="3v7zx9gwsuynb">
            <h4 className="text-white font-bold mb-4" data-id="element-160" data-mp="3v8hqs5s2uyrj">Quick Links</h4>
            <ul className="space-y-2 text-sm" data-id="element-161" data-mp="3q83tnis0l98a">
              <li data-id="element-162" data-mp="3q7bvq1ay2zeu">
                <a href="#why-us" className="hover:text-brand-accent transition-colors" data-id="element-163" data-mp="3qazrz87rxzx9">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-164" data-mp="hstt4f3rwc2m">
                <a href="#results" className="hover:text-brand-accent transition-colors" data-id="element-165" data-mp="htd0x2zplk2x">
                  Case Results
                </a>
              </li>
              <li data-id="element-166" data-mp="qsqadvnu28nn">
                <a href="#faq" className="hover:text-brand-accent transition-colors" data-id="element-167" data-mp="qu1gi24r3shx">
                  Mesothelioma FAQ
                </a>
              </li>
              <li data-id="element-168" data-mp="twxuvjrohse2">
                <a href="#contact" className="hover:text-brand-accent transition-colors" data-id="element-169" data-mp="tta0yjibn3yt">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-170" data-mp="18k92xboniu9f">
            <h4 className="text-white font-bold mb-4" data-id="element-171" data-mp="18ksmsxxv3sq3">Contact</h4>
            <ul className="space-y-2 text-sm" data-id="element-172" data-mp="1cm43uf2o75mo">
              <li data-id="element-173" data-mp="1clcjy1ifqwc8">
                <a href="tel:805-770-9317" className="hover:text-brand-accent transition-colors font-bold text-white" data-id="element-174" data-mp="1cnyqbxtlb5sv">
                  (805) 770-9317
                </a>
              </li>
              <li data-id="element-175" data-mp="1rj4z2sk2lipw">100 Legal Way, Suite 500</li>
              <li data-id="element-176" data-mp="1rgshigi85add">Los Angeles, CA 90001</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 text-xs text-slate-500 space-y-4" data-id="element-177" data-mp="3oczof8dimd4z">
          <p data-id="element-178" data-mp="3tarquwbsdhnf">
            <strong data-id="element-179" data-mp="3tcccfwg4hq95">Disclaimer:</strong> The information on this website is for
            general information purposes only. Nothing on this site should be
            taken as legal advice for any individual case or situation. This
            information is not intended to create, and receipt or viewing does
            not constitute, an attorney-client relationship.
          </p>
          <p data-id="element-180" data-mp="1wpjuoxoe0ugn">
            Past results are not a guarantee of future outcomes. Every case is
            different and must be judged on its own merits.
          </p>
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-4" data-id="element-181" data-mp="2pc4i5n1qsmex">
            <p data-id="element-182" data-mp="2kci6hi1kbe88">
              &copy; {new Date().getFullYear()} Pacific Coast Mesothelioma Law
              Group. All Rights Reserved.
            </p>
            <div className="flex gap-4" data-id="element-183" data-mp="2fgb2vvwn2etg">
              <a href="#" className="hover:text-white transition-colors" data-id="element-184" data-mp="18yeg0lu6o87x">
                Privacy Policy
              </a>
              <a href="#" className="hover:text-white transition-colors" data-id="element-185" data-mp="13y9ycshjh7g4">
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}